import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import OptimizeImagesService from 'services/OptimizeImages.service';

import messages from './StrategyView.intl';

//styles
import styles from './StrategyView.module.scss';

//components
import { Container, Title } from 'common/components/Layout/Layout';
import ShortComment from 'common/components/ShortComment/ShortComment';
import ProfitItem from './components/ProfitItem/ProfitItem';
import DualPhotoSection from 'common/components/DualPhotoSection/DualPhotoSection';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import BackgroundWithCite from 'common/components/Placeholder/components/BackgroundWithCite/BackgroundWithCite';

@injectIntl
@observer
export default class StrategyView extends Component {
  render() {
    const content = ContentStore.content;
    const commentSize = { width: 90, height: 106 };

    return (
      <div className={styles.StrategyView}>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.strategySEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Placeholder component={<BackgroundWithCite />} ready={!!content}>
          {ContentStore.isLoaded && (
            <div
              className={styles.SectionBG}
              style={{
                backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                  content.StrategyBackgroundImage
                )})`
              }}
            >
              <Container>
                <div className={styles.CommentContainer}>
                  <ShortComment
                    comment={content.StrategyComment}
                    size={commentSize}
                    className={styles.Comment}
                  />
                </div>
              </Container>
            </div>
          )}
        </Placeholder>
        {ContentStore.isLoaded && (
          <Container>
            <div className={styles.ProfitContainer}>
              <div className={styles.TitleContainer}>
                <h2 className={styles.ProfitTitle}>
                  {this.props.intl.formatMessage(messages.profitTitle)}
                </h2>
              </div>
              {content.StrategySpecialization.map(item => (
                <ProfitItem
                  key={item.id}
                  specialization={item}
                  className={styles.ProfitItem}
                />
              ))}
            </div>
          </Container>
        )}
        {ContentStore.isLoaded && (
          <DualPhotoSection
            image={content.StrategyInfoImage}
            text={content.StrategyInfoText}
            title={content.StrategyInfoTitle}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Strategy/StrategyView.js